// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserGetUserbyAuth0IdIdGetUserbyAuth0IdResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserGetUserbyAuth0IdIdGetUserbyAuth0IdResponse.attributeTypeMap;
    }
}
AuthenticationV2UserGetUserbyAuth0IdIdGetUserbyAuth0IdResponse.discriminator = undefined;
AuthenticationV2UserGetUserbyAuth0IdIdGetUserbyAuth0IdResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=authenticationV2UserGetUserbyAuth0IdIdGetUserbyAuth0IdResponse.js.map